import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { userReviews } from "../../../reducers/orderDetailsReducer";
import { Link } from "react-router-dom";
import NoRecordFound from "../../Sub/NoRecordFound";
import { Button, Form, Row, Col, Container } from "react-bootstrap";
import AddUserReview from "./AddUserReview";

const UserReview = () => {
  const dispatch = useDispatch();
  const { userReviewsList } = useSelector((state) => state.orderDetailReducer);
  useEffect(() => {
    dispatch(userReviews());
  }, []);
  const productRating = (star, times) => {
    var repeatedString = "";
    while (times > 0) {
      repeatedString += star;
      times--;
    }
    return repeatedString;
  };
  return (
    <>
      {userReviewsList.length > 0 ? (
        userReviewsList.map((data, index) => {
          return (
            <div className="row p-4  " key={index} >
              <div className="mt-2 col-md-12 ">
                <div className="border-y mb-1 d-md-flex justify-content-between ">
                 <Col>
                 
                 <h1 className="mb-0">{data?.name}</h1>
                  <strong> 
                    {moment(data?.createdAt).format("DD/MM/YYYY")}
                  </strong>
                  <br />
                  {<strong>{productRating(data?.rating)}</strong>}</Col>

                   <Col className="text-end">
                  
                                 {!!localStorage.getItem("x-auth-token") &&
                                             
                                                <AddUserReview />
                                              }<br />
                              </Col>
                </div>
                <h3>{data?.title}</h3>
                <h5>{data?.description}</h5>
                {/* <p>
                  <span className="review-status">
                    <Link to={`/product/${data?.product?.slug}`}>
                      View Product
                    </Link>
                  </span>{" "}
                  <span className="review-status">{data?.status}</span>
                </p> */}
              </div>
            </div>
          );
        })
      ) : (
        <NoRecordFound />
      )}
    </>
  );
};

export default UserReview;
